import React, { useState, useEffect } from "react";
import styled from "styled-components";
import bannerImg from "../../assets/homeAssets/bannerImg2.png";
import mobileBannerImg from "../../assets/homeAssets/mobileBannerImg2.png"; // Import your mobile image

const Banner2 = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkScreenSize();

    // Add event listener
    window.addEventListener("resize", checkScreenSize);

    // Clean up
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <Container>
      <div className="text-content">
        <div className="text-background-blur"></div>
        {/* <h1 className="title">
          Für <span>Ergebnisse</span> <br /> müssen Sie nichts <br />{" "}
          <span>erklären</span>
        </h1> */}
        <h1 className="title">Sektori tjeter vazhdon ktu</h1>
        <p className="subtitle">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui rem
          cupiditate reiciendis?
        </p>
        {/* <button className="shop-btn">BOOK NOW</button> */}
      </div>
      <div className="image-container">
        {/* <img src={isMobile ? mobileBannerImg : bannerImg} alt="Banner" /> */}
      </div>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 85vh;
  background: #daccbd;
  display: flex;
  align-items: center;
  position: relative;

  .image-container {
    position: absolute;
    right: 15%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    height: 80vh;
    max-height: 80%;
    object-fit: contain;
  }

  .text-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    max-width: 900px;
    color: #6d6357;
    margin-left: 15%;
    position: relative;
    z-index: 2;
    span {
      color: #948169;
    }

    /* Text animation */
    opacity: 0;
    transform: translateX(-30px);
    animation: textReveal 0.8s ease-out forwards;
    animation-delay: 1s;

    @keyframes textReveal {
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }

  .text-background-blur {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 800px; /* Same as max-width of text-content */
    height: 800px; /* Perfect circle */
    background: radial-gradient(
      circle at center,
      rgba(255, 255, 255, 0.904) 0%,
      rgba(255, 255, 255, 0.397) 20%,
      rgba(255, 255, 255, 0.377) 50%,
      rgba(255, 255, 255, 0.02) 70%,
      rgba(255, 255, 255, 0) 100%
    );
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-radius: 50%;
    z-index: 1;
    opacity: 0;
    animation: blurReveal 0.8s ease-out forwards;
    animation-delay: 0.5s;

    @keyframes blurReveal {
      to {
        opacity: 1;
      }
    }
  }

  .title {
    font-size: 5vw;
    font-weight: 500;
    margin-bottom: 25px;
    line-height: 1.1;
    text-shadow: 3px 3px 6px rgba(241, 235, 228, 0.4);
    color: #5a5248;
    position: relative;
    z-index: 2;
    font-family: "Mr Dafoe", cursive;
  }

  .subtitle {
    font-size: 1rem;
    margin-bottom: 35px;
    line-height: 1.7;
    color: #6d6357;
    text-shadow: 1px 1px 3px rgba(241, 235, 228, 0.6);
    font-weight: 500;
    position: relative;
    z-index: 2;
  }

  .shop-btn {
    background: #6d6357;
    color: white;
    border: none;
    padding: 16px 40px;
    font-size: 1.2rem;
    font-weight: 600;
    border-radius: 35px;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 6px 20px rgba(109, 99, 87, 0.4);
    font-family: "Poppins", cursive;
    position: relative;
    overflow: hidden;
    z-index: 2;

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 0;
      height: 0;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      transform: translate(-50%, -50%);
      transition: width 0.6s, height 0.6s;
    }

    &:hover {
      background: #5a5248;
      transform: translateY(-4px);
      box-shadow: 0 10px 25px rgba(109, 99, 87, 0.5);

      &::after {
        width: 300px;
        height: 300px;
      }
    }

    &:active {
      transform: translateY(-1px);
      box-shadow: 0 5px 15px rgba(109, 99, 87, 0.4);
    }
  }

  @media (max-width: 768px) {
    height: 100vh;

    .text-content {
      justify-content: flex-start;
      margin-top: 15em;
      margin-left: 10%;

      .title {
        font-size: 12vw;
      }

      .subtitle {
        padding: 0 20px;
      }

      .shop-btn {
      }
    }

    .text-background-blur {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -180%);
      width: 300px;
      height: 300px;
      background: radial-gradient(
        circle at center,
        rgba(255, 255, 255, 0.904) 0%,
        rgba(255, 255, 255, 0.397) 20%,
        rgba(255, 255, 255, 0.164) 50%,
        rgba(255, 255, 255, 0.02) 70%,
        rgba(255, 255, 255, 0) 100%
      );
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      border-radius: 50%;
      z-index: 1;
      opacity: 0;
      animation: blurReveal 0.8s ease-out forwards;
      animation-delay: 0.5s;
    }

    .image-container {
      right: 0;
      top: 40%;
      height: auto;
      width: 100%;
      margin-top: 2em;

      img {
        height: auto;
        width: 100%;
        max-height: 100vh;
        object-fit: contain;
      }
    }
  }

  /* @media (max-width: 480px) {
    height: 90vh;

    .text-content {
      margin-top: 3em;

      .title {
        font-size: 14vw;
      }

      .subtitle {
        font-size: 0.9rem;
        padding: 0 15px;
      }
    }

    .text-background-blur {
      width: 250px;
      height: 250px;
    }

    .image-container {
      img {
        max-height: 35vh;
      }
    }
  } */
`;

export default Banner2;
